import { render, staticRenderFns } from "./BotManageImagePosts.vue?vue&type=template&id=6ec61e93&"
import script from "./BotManageImagePosts.vue?vue&type=script&lang=js&"
export * from "./BotManageImagePosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports